import type { QuizDefinition } from "@/schema/quizSchema";
import { placeholderQuiz } from "@/quizzes/placeholder";
import { baiaMicrobiotaQuiz } from "@/quizzes/baia-microbiota";
import { auralPielPeloQuiz } from "@/quizzes/aural-piel-pelo";
import { manlyQuiz } from "@/quizzes/manly-quiz";
import { manlyHormoneQuiz } from "@/quizzes/manly-hormone-quiz";

export const quizRegistry: Record<string, QuizDefinition> = {
  [placeholderQuiz.slug]: placeholderQuiz,
  [baiaMicrobiotaQuiz.slug]: baiaMicrobiotaQuiz,
  [auralPielPeloQuiz.slug]: auralPielPeloQuiz,
  [manlyQuiz.slug]: manlyQuiz,
  [manlyHormoneQuiz.slug]: manlyHormoneQuiz,
};

export function getQuiz(slug: string): QuizDefinition | undefined {
  return quizRegistry[slug];
}
